import { useRef, useEffect } from 'react'

// Live-page PPTX bridge (pptx.coffee -> block.getDisplayRange). The block needs the axis
// range actually on screen — including any user zoom — which only the mounted chart knows;
// its own recompute from the answer deliberately differs (it widens by the confidence
// interval). Before the charts moved to React the block read the axis off the legacy
// chart-model wrapper; nothing builds that for a React chart, so the chart hands an
// accessor back instead, mirroring how the Conjoint renderer exposes its SVG serializers.
//
// Returns the ref to pass to ChartContainer's `chartRef`. The api object identity is stable,
// so onChartReady only has to hand it over once, while the accessor reads the ref live.
export const useChartAxisApi = onChartReady => {
  const chartRef = useRef(null)
  const apiRef = useRef({})

  apiRef.current.getAxisExtremes = () => {
    const axis = chartRef.current?.chart?.yAxis?.[0]
    if (!axis || axis.min == null || axis.max == null) return null
    return [axis.min, axis.max]
  }

  useEffect(() => {
    onChartReady?.(apiRef.current)
  }, [onChartReady])

  return chartRef
}
